//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        msg: Object
    },
    data () {
        return {
            reading: false
        }
    },
    methods: {
        play() {
            this.reading = true
        },
        pause() {
            this.reading = false
        }
    }
}
